import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers'
import Store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  Store.dispatch('fetchWhatsapp', to.meta.whatsapp ?? true)
  const user = localStorage.getItem('auth')

  if (to.path === '/login' && user) {
    next({ path: from.path })
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      next({ path: '/login' })
      return
    }

    const userRole = localStorage.getItem('userRole')
    if (to.matched.some(record => record.meta.blockedRoles?.includes(userRole))) {
      // The client approver has no access to the process list, so it falls back to Approvals.
      next({ path: userRole === 'CLIENT_APPROVER' ? '/aprobaciones' : '/buscar-proceso' })
      return
    }

    // allowedRoles: whitelist, for pages only some roles may open (e.g. the digital report).
    if (to.matched.some(record => record.meta.allowedRoles && !record.meta.allowedRoles.includes(userRole))) {
      next({ path: '/buscar-proceso' })
      return
    }

    next()
  } else {
    next()
  }
})

export default router
